import React from 'react';
import { Grid, Typography, Box, Card, CardContent } from "@mui/material";
import { ComTypography } from '../commonFields/ComTypography';
import useMediaQuery from '@mui/material/useMediaQuery';
import "./../about/Aboutus.css";
import client from "./../images/client.jpg";
import "./Style.css";


const Client = () => {
  const vMediaQuery = useMediaQuery('(max-width:600px)');

  const clientHead = {
    display: "flex",
    margin: 'auto',
    padding: vMediaQuery ? "0px" : "16px",
    boxShadow: 0,

  }

  const explore = {
    padding: vMediaQuery ? "0px" : "20px 30px 20px 60px"
  }
  return (
    <div>
      <Box sx={{ flexGrow: 1, padding: vMediaQuery ? "30px 20px" : "40px 180px 40px 100px" }}>
        <Card className='cards' sx={clientHead} >
          <CardContent>
            <Grid container spacing={0}>
              <Grid item xs={12} md={8} lg={8} sx={explore} >
                <Typography variant={'h3'} className={'client'} sx={{ color: "#898b8c", fontSize: vMediaQuery ? "28px" : "50px", fontWeight: 500, fontFamily: "EB Garamond", }}>What <strong style={{ fontWeight: 800, color: 'green', fontFamily: "EB Garamond", }}> our clients </strong> <br />have to say about us</Typography>
                <ComTypography variant={"body1"} text={"It’s a breath of fresh air to be able to trust the knowledge and expertise of GDR Consultancy's team. We chose GDR Consultancy because of its strong client referrals. The team have been so wonderful to work with and it’s so much better knowing we’re getting things done correctly."} />
              </Grid>
              <Grid item xs={12} md={4} lg={4} >
                <div className="headimg-contanier">
                  <img className="clientImg" alt="explore" src={client} />
                </div>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
      </Box>
    </div>
  )
}

export default Client;